import cn from 'classnames';
import type { FC } from 'react';
import { Moderation } from '@shared/assets';
import * as st from './EventModeration.module.scss';

interface Props {
  status: string;
  published: boolean;
  publicate: () => void;
  // showModerationStatus: () => void;
  showModerationText: () => void;
}

const EventModeration: FC<Props> = ({
  status,
  published,
  publicate,
  // showModerationStatus,
  showModerationText,
}) => {
  return (
    <>
      {!published && (
        <div className={cn(st.wrapper, st.publish)}>
          <p>Не опубликовано</p>
          {/* <p className={st.unpublished}>Опубликовать</p> */}
          <div className={st.icon__wrapper}>
            <Moderation />
          </div>
        </div>
      )}

      {published && status == 'N' && (
        <div className={cn(st.wrapper, st.moderation)}>
          <p>Модерация</p>
          <div className={st.icon__wrapper}>
            <Moderation />
          </div>
        </div>
      )}
      {published && status === 'D' && (
        <div className={cn(st.wrapper, st.ban)} onClick={showModerationText}>
          <p>Модерация не пройдена</p>
          <div className={st.icon__wrapper}>
            <Moderation />
          </div>
        </div>
      )}
    </>
  );
};

export default EventModeration;
